import React from "react";

const CurrencyIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      fill="currentColor"
      viewBox="0 0 8 14"
    >
      <path d="M7.378 9.326c0 .448-.112.877-.336 1.288a2.775 2.775 0 01-.994 1.008c-.43.27-.947.425-1.554.462v1.134h-.756v-1.134c-.85-.075-1.54-.345-2.072-.812-.532-.476-.803-1.078-.812-1.806h1.358c.037.392.182.733.434 1.022.261.29.625.471 1.092.546v-3.5c-.625-.159-1.13-.322-1.512-.49a2.473 2.473 0 01-.98-.784C.976 5.905.84 5.43.84 4.832c0-.756.261-1.381.784-1.876.532-.495 1.237-.77 2.114-.826V.968h.756V2.13c.793.065 1.433.322 1.918.77.485.439.765 1.013.84 1.722H5.894a1.611 1.611 0 00-.434-.882c-.243-.27-.565-.448-.966-.532v3.416c.616.159 1.115.322 1.498.49.392.159.719.415.98.77.27.355.406.835.406 1.442zM2.142 4.762c0 .457.135.807.406 1.05.27.243.667.443 1.19.602V3.18c-.485.047-.873.205-1.162.476-.29.261-.434.63-.434 1.106zm2.352 6.286c.504-.056.896-.238 1.176-.546.29-.308.434-.677.434-1.106 0-.457-.14-.807-.42-1.05-.28-.252-.677-.453-1.19-.602v3.304z"></path>
    </svg>
  );
};

export default CurrencyIcon;
